import styled from 'styled-components';
import {
  blue, grey, red, darkerGrey, tekoMedium, openSans, openSansLight,
} from '../../../utils/theme';
import { mobile, tablet } from '../../../utils/breakpoints';
import { BlueButton } from '../../../utils/atoms';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding: 60px 70px 100px 70px;
  position: relative;

  .xfl-signup__form {
    margin-top: 100px;
  }

  @media (max-width: ${mobile.max}px) {
    padding: 30px 30px 40px;

    .xfl-signup__form {
      margin-top: 30px;
    }

    .xfl-signup__captcha {
      display: flex;
      justify-content: center;
    }

    .component-title {
      margin: 0 auto;
    }
  }

  #signup {
    position: relative;
  }

  h2 {
    ${tekoMedium} font-size: 38px;
    color: ${blue};
    letter-spacing: 4px;
    margin-top: 5px;

    @media (max-width: ${mobile.max}px) {
      font-size: 24px;
      letter-spacing: 2.5px;
      margin: 15px 0 25px;
    }
  }

  .description {
    margin-bottom: 60px;
  }
  
  .content-html {
    p {
      ${openSans} font-size: 14px;
      color: ${darkerGrey};
      letter-spacing: 1.4px;
      line-height: 22px;
      max-width: 580px;
      margin-top: 19px;
  
      @media (max-width: ${mobile.max}px) {
        margin: 0;
        display: block;
        margin-bottom: 25px;
      }
    }
  }

  .error {
    display: block;
    margin: 20px auto 0;
    text-align: center;
    color: ${red};
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 50px 0 30px 0;
  @media (max-width: ${mobile.max}px) {
    display: block;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  padding-top: 10px;
  margin: 15px 30px 15px 0;
  flex-basis: 500px;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-grow: 1;
  flex-shrink: 0;

  input {
    width: 100%;
    ${openSansLight} font-size: 38px;
    color: ${blue};
    padding-left: 0;
    border-bottom: 1px solid ${blue};
    margin-bottom: 10px;
    font-size: 28px;
    
    &.input-name {
      width: 45%;
    }

    ::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      ${openSansLight} font-size: 28px;
      color: ${grey};
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      ${openSansLight} font-size: 28px;
      color: ${grey};
    }
    :-ms-input-placeholder {
      /* IE 10+ */
      ${openSansLight} font-size: 28px;
      color: ${grey};
    }
    :-moz-placeholder {
      /* Firefox 18- */
      ${openSansLight} font-size: 28px;
      color: ${grey};
    }
  }
  @media (max-width: ${tablet.max}px) {
    input {
      font-size: 28px;
      
      &.input-name {
        width: 100%;
      }
    }
  }
  @media (max-width: ${mobile.max}px) {
    display: block;
    width: 100%;
    margin-bottom: 20px;
    padding: 0;

    input {
      font-size: 20px;
      height: auto;
      padding-bottom: 7px;

      ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        font-size: 20px;
      }
      ::-moz-placeholder {
        /* Firefox 19+ */
        font-size: 20px;
      }
      :-ms-input-placeholder {
        /* IE 10+ */
        font-size: 20px;
      }
      :-moz-placeholder {
        /* Firefox 18- */
        font-size: 20px;
      }
    }
  }
`;

export const SignupBtn = styled(BlueButton)`
  margin: 15px 0;

  @media (max-width: ${mobile.max}px) {
    display: block;
    position: relative;
    margin: 30px auto 0 auto;
    width: 160px;
    text-align: center;
    font-size: 47px;
    top: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/sign-up/styles/signup.style.js